export default class RegionsMap {
    constructor(element) {
        const tooltip = document.querySelector('.map-tooltip')
        const allPaths = element.querySelectorAll('path')

        allPaths.forEach(county => {
            county.addEventListener('mouseleave', this.onMouseLeave(tooltip))
            county.addEventListener('mouseenter', this.onMouseEnter(tooltip))
            county.addEventListener('mousemove', this.onMouseMove(element, tooltip))
        });
    }

    onMouseEnter = (tooltip) => {
        return (e) => {
            e.target.classList.toggle('active')
            tooltip.style.display = 'block'
            tooltip.querySelector('.map-tooltip__title').innerHTML = e.target.dataset.tooltipTitle
            tooltip.querySelector('.map-tooltip__text').innerHTML = e.target.dataset.tooltipText
        }
    }

    onMouseLeave = (tooltip) => {
        return (e) => {
            e.target.classList.toggle('active')
            tooltip.style.display = 'none'
        }
    }

    onMouseMove = (el, tooltip) => {
        return (e) => {
            let bounds = el.getBoundingClientRect();
            tooltip.style.top = e.clientY - bounds.top + 'px';
            tooltip.style.left = e.clientX - bounds.left + 'px';
        }
    }
}